import {
  Col,
  Row,
  Label,
  Input,
  Card,
  CardBody,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import React, { useEffect, useState } from "react";
import StorefrontOutlinedIcon from "@mui/icons-material/StorefrontOutlined";
import AppModal from "../../Common/AppModal";
import { isEmpty } from "lodash";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import {
  addSingleCustomerSiteLocation,
  addSingleCustomerSiteLocationSuccess,
  getCustomersListData,
  getSingleCustomersData,
  getSingleCustomerSiteLocationListData,
  updateSingleCustomerSiteLocation,
  updateSingleCustomerSiteLocationSuccess,
} from "../../../store/customers/action";

import "./createEditCustomer.scss";

import classnames from "classnames";

import { TabStepABusinessNameAndAddress } from "./tabStepABusinessNameAndAddress";
import { TabStepBBusinessContactInformation } from "./tabStepBBusinessContactInformation";

import MapDetails from "../../../pages/Customer/single/tabOverview/mapDetails";
import {
  foodPreOrderSiteLocationCreate,
  foodPreOrderSiteLocationCreateSuccess,
  foodPreOrderSiteLocationList,
  foodPreOrderSiteLocationUpdate,
  foodPreOrderSiteLocationUpdateSuccess,
} from "../../../store/foodPreOederEvent/action";
import LoadingSpinner from "../../Common/Spinner";
import { TabStepCBranding } from "./tabStepCBranding";

export default function CreateEditCustomerSiteLocation({
  modal,
  fromCustomerPage,
  Customer_Id,
  setModal,
  toggle,
  setIsEdit,
  isEdit,
  page,
  // Change #100425 - told the new location's Id, so a caller that opened this
  // "on the fly" (the job popup) can select it straight away.
  onCreated,
}) {
  const dispatch = useDispatch();
  const localLogo = JSON.parse(localStorage.getItem("authUser"))
    ?.get_company_data?.Company_LogoUrl;
  const initialCustomerDetails = {
    CustomerSiteLocationBusinessType_Id: "",
    Customer_Id: Customer_Id ?? "",
    BusinessName: "",
    PersonTitle: "",
    PersonFirstName: "",
    PersonLastName: "",
    AddressLine1: "",
    AddressLine2: "",
    AddressLine3: "",
    AddressLine4: "",
    AddressCity: "",
    AddressCounty: "",
    AddressPostCode: "",
    AddressCountry: "",
    SiteReference: "",
    contactemailaddress_list: [
      {
        Id: 1,
        EmailAddress: "",
      },
    ],
    contacttelephonenumber_list: [
      {
        Id: 1,
        TelephoneNumber: "",
      },
    ],
    //branding
    PortalCssColourPageBackground: "",
    PortalCssColourDivBackground: "",
    PortalCssColourDivHeading: "",
    PortalCssFontFamilyDivHeading: "",
    PortalCssColourDivText: "",
    PortalCssFontFamilyDivTextPortalCssFontFamilyDivText: "",
    PortalCssButtonTextColour: "",
    PortalCssButtonBackgroundColour: "",
    PortalCssEmailHeadingTextColour: "",

    //urls & notes
    ContactTelephoneNumber: "",
    ContactEmailAddress: "",
    UrlWebsiteHomepage: "",
    UrlWebsiteBookATable: "",
    UrlLeaveAReview: "",
    UrlLeaveFeedback: "",
    Notes: "",
    //logo
    LogoUrl: localLogo,
  };

  const [customerDetails, setCustomerDetails] = useState(
    initialCustomerDetails
  );
  console.log("customerDetails", customerDetails);
  const { singleCustomerSiteLocationDataAPI, foodPreOrderSiteLocationDataAPI } =
    useSelector((state) => ({
      singleCustomerSiteLocationDataAPI:
        state.Customers.singleCustomerSiteLocationData
          ?.customersitelocation_data,
      foodPreOrderSiteLocationDataAPI:
        state.FoodPreOrderEventReducer.foodPreOrderSiteLocationData
          ?.foodpreordersitelocation_data,
    }));

  // Get from API and assign to customerDetails
  useEffect(() => {
    if (isEdit) return;
    setCustomerDetails(initialCustomerDetails);
  }, [isEdit]);

  useEffect(() => {
    if (isEmpty(foodPreOrderSiteLocationDataAPI)) return;
    setCustomerDetails({
      Id: foodPreOrderSiteLocationDataAPI?.Id,
      CustomerSiteLocationBusinessType_Id:
        foodPreOrderSiteLocationDataAPI?.CustomerSiteLocationBusinessType_Id,
      Customer_Id: foodPreOrderSiteLocationDataAPI?.Customer_Id,
      BusinessName: foodPreOrderSiteLocationDataAPI?.BusinessName,
      PersonTitle: foodPreOrderSiteLocationDataAPI?.PersonTitle,
      PersonFirstName: foodPreOrderSiteLocationDataAPI?.PersonFirstName,
      PersonLastName: foodPreOrderSiteLocationDataAPI?.PersonLastName,
      AddressLine1: foodPreOrderSiteLocationDataAPI?.AddressLine1,
      AddressLine2: foodPreOrderSiteLocationDataAPI?.AddressLine2,
      AddressLine3: foodPreOrderSiteLocationDataAPI?.AddressLine3,
      AddressLine4: foodPreOrderSiteLocationDataAPI?.AddressLine4,
      AddressCity: foodPreOrderSiteLocationDataAPI?.AddressCity,
      AddressCounty: foodPreOrderSiteLocationDataAPI?.AddressCounty,
      AddressPostCode: foodPreOrderSiteLocationDataAPI?.AddressPostCode,
      AddressCountry: foodPreOrderSiteLocationDataAPI?.AddressCountry,
      SiteReference: foodPreOrderSiteLocationDataAPI?.SiteReference,
      contactemailaddress_list: !isEmpty(
        foodPreOrderSiteLocationDataAPI?.contactemailaddress_list
      )
        ? foodPreOrderSiteLocationDataAPI?.contactemailaddress_list?.map(
            (item) => {
              return {
                Id: item.Id,
                EmailAddress: item.EmailAddress ?? "",
              };
            }
          )
        : [
            {
              Id: "1",
              EmailAddress: "",
            },
          ],
      contacttelephonenumber_list: !isEmpty(
        foodPreOrderSiteLocationDataAPI?.contacttelephonenumber_list
      )
        ? foodPreOrderSiteLocationDataAPI?.contacttelephonenumber_list?.map(
            (item) => {
              return {
                Id: item?.Id,
                TelephoneNumber: item?.TelephoneNumber,
              };
            }
          )
        : [
            {
              Id: "1",
              TelephoneNumber: "",
            },
          ],
      //branding
      PortalCssColourPageBackground:
        foodPreOrderSiteLocationDataAPI?.PortalCssColourPageBackground,
      PortalCssColourDivBackground:
        foodPreOrderSiteLocationDataAPI?.PortalCssColourDivBackground,
      PortalCssColourDivHeading:
        foodPreOrderSiteLocationDataAPI?.PortalCssColourDivHeading,
      PortalCssFontFamilyDivHeading:
        foodPreOrderSiteLocationDataAPI?.PortalCssFontFamilyDivHeading,
      PortalCssColourDivText:
        foodPreOrderSiteLocationDataAPI?.PortalCssColourDivText,
      PortalCssFontFamilyDivTextPortalCssFontFamilyDivText:
        foodPreOrderSiteLocationDataAPI?.PortalCssFontFamilyDivTextPortalCssFontFamilyDivText,
      PortalCssButtonTextColour:
        foodPreOrderSiteLocationDataAPI?.PortalCssButtonTextColour,
      PortalCssButtonBackgroundColour:
        foodPreOrderSiteLocationDataAPI?.PortalCssButtonBackgroundColour,
      PortalCssEmailHeadingTextColour:
        foodPreOrderSiteLocationDataAPI?.PortalCssEmailHeadingTextColour,
      //urls & notes
      ContactTelephoneNumber: foodPreOrderSiteLocationDataAPI?.ContactTelephoneNumber || "",
      ContactEmailAddress: foodPreOrderSiteLocationDataAPI?.ContactEmailAddress || "",
      UrlWebsiteHomepage: foodPreOrderSiteLocationDataAPI?.UrlWebsiteHomepage || "",
      UrlWebsiteBookATable: foodPreOrderSiteLocationDataAPI?.UrlWebsiteBookATable || "",
      UrlLeaveAReview: foodPreOrderSiteLocationDataAPI?.UrlLeaveAReview || "",
      UrlLeaveFeedback: foodPreOrderSiteLocationDataAPI?.UrlLeaveFeedback || "",
      Notes: foodPreOrderSiteLocationDataAPI?.Notes || "",
      //logo
      LogoUrl: foodPreOrderSiteLocationDataAPI?.LogoUrl,
    });
  }, [foodPreOrderSiteLocationDataAPI]);

  useEffect(() => {
    if (!isEdit) return;
    if (isEmpty(singleCustomerSiteLocationDataAPI)) return;
    setCustomerDetails({
      Id: singleCustomerSiteLocationDataAPI?.customersitelocation_data?.Id,
      Customer_Id: singleCustomerSiteLocationDataAPI?.Customer_Id,
      CustomerSiteLocationBusinessType_Id:
        singleCustomerSiteLocationDataAPI?.customersitelocation_data
          ?.CustomerSiteLocationBusinessType_Id,
      BusinessName:
        singleCustomerSiteLocationDataAPI?.customersitelocation_data
          ?.BusinessName,
      PersonTitle:
        singleCustomerSiteLocationDataAPI?.customersitelocation_data
          ?.PersonTitle,
      PersonFirstName:
        singleCustomerSiteLocationDataAPI?.customersitelocation_data
          ?.PersonFirstName,
      PersonLastName:
        singleCustomerSiteLocationDataAPI?.customersitelocation_data
          ?.PersonLastName,
      AddressLine1:
        singleCustomerSiteLocationDataAPI?.customersitelocation_data
          ?.AddressLine1,
      AddressLine2:
        singleCustomerSiteLocationDataAPI?.customersitelocation_data
          ?.AddressLine2,
      AddressLine3:
        singleCustomerSiteLocationDataAPI?.customersitelocation_data
          ?.AddressLine3,
      AddressLine4:
        singleCustomerSiteLocationDataAPI?.customersitelocation_data
          ?.AddressLine4,
      AddressCity:
        singleCustomerSiteLocationDataAPI?.customersitelocation_data
          ?.AddressCity,
      AddressCounty:
        singleCustomerSiteLocationDataAPI?.customersitelocation_data
          ?.AddressCounty,
      AddressPostCode:
        singleCustomerSiteLocationDataAPI?.customersitelocation_data
          ?.AddressPostCode,
      AddressCountry:
        singleCustomerSiteLocationDataAPI?.customersitelocation_data
          ?.AddressCountry,
      SiteReference:
        singleCustomerSiteLocationDataAPI?.customersitelocation_data
          ?.SiteReference,

      contactemailaddress_list: !isEmpty(
        singleCustomerSiteLocationDataAPI?.contactemailaddress_list
      )
        ? singleCustomerSiteLocationDataAPI?.contactemailaddress_list?.map(
            (item) => {
              return {
                Id: item.Id,
                EmailAddress: item.EmailAddress ?? "",
              };
            }
          )
        : [
            {
              Id: "1",
              EmailAddress: "",
            },
          ],
      contacttelephonenumber_list: !isEmpty(
        singleCustomerSiteLocationDataAPI?.contacttelephonenumber_list
      )
        ? singleCustomerSiteLocationDataAPI?.contacttelephonenumber_list?.map(
            (item) => {
              return {
                Id: item?.Id,
                TelephoneNumber: item?.TelephoneNumber,
              };
            }
          )
        : [
            {
              Id: "1",
              TelephoneNumber: "",
            },
          ],
    });
  }, [singleCustomerSiteLocationDataAPI, isEdit]);

  // Access Redux State
  const {
    createSingleCustomerSiteLocationResponseAPI,
    updateSingleCustomerSiteLocationResponseAPI,
    loading,
    foodPreOrderSiteLocationCreateAPI,
    foodPreOrderSiteLocationCreateLoading,
    foodPreOrderSiteLocationUpdateAPI,
    foodPreOrderSiteLocationUpdateLoading,
  } = useSelector((state) => ({
    createSingleCustomerSiteLocationResponseAPI:
      state.Customers.createSingleCustomerSiteLocationResponse,
    updateSingleCustomerSiteLocationResponseAPI:
      state.Customers.updateSingleCustomerSiteLocationResponse,
    loading: state.Customers.loading,
    foodPreOrderSiteLocationCreateAPI:
      state.FoodPreOrderEventReducer.foodPreOrderSiteLocationCreate,
    foodPreOrderSiteLocationCreateLoading:
      state.FoodPreOrderEventReducer.foodPreOrderSiteLocationCreateLoading,
    foodPreOrderSiteLocationUpdateAPI:
      state.FoodPreOrderEventReducer.foodPreOrderSiteLocationUpdate,
    foodPreOrderSiteLocationUpdateLoading:
      state.FoodPreOrderEventReducer.foodPreOrderSiteLocationUpdateLoading,
  }));
  const [createAndStayOrView, setCreateAndStayOrView] = useState("");

  // Handle Create Customer
  const handleCreateCustomer = (view) => {
    if (view === "view") {
      setCreateAndStayOrView("view");
    }

    const sendData = [customerDetails];
    if (page === "eventPreOrderLocations") {
      dispatch(foodPreOrderSiteLocationCreate(sendData));
    } else {
      dispatch(addSingleCustomerSiteLocation(sendData));
    }
  };
  // handle Edit Update Customer
  const handleEditCustomer = () => {
    const sendData = [customerDetails];
    if (page === "eventPreOrderLocations") {
      dispatch(foodPreOrderSiteLocationUpdate(sendData));
    } else {
      dispatch(updateSingleCustomerSiteLocation(sendData));
    }
  };

  //Update Customer Validation response handler
  useEffect(() => {
    if (isEmpty(updateSingleCustomerSiteLocationResponseAPI)) return;
    if (updateSingleCustomerSiteLocationResponseAPI.status === 200) {
      dispatch(
        getSingleCustomerSiteLocationListData([
          {
            customer_data: {
              Id: Customer_Id,
            },
          },
        ])
      );
      toast.success(updateSingleCustomerSiteLocationResponseAPI?.message);
      setModal(false);
      // reset customer details object to default
      setCustomerDetails(initialCustomerDetails);
    } else {
      toast.error(updateSingleCustomerSiteLocationResponseAPI?.message);
    }
    dispatch(updateSingleCustomerSiteLocationSuccess([]));
  }, [updateSingleCustomerSiteLocationResponseAPI]);
  // Create Customer Validation response handler

  useEffect(() => {
    if (isEmpty(createSingleCustomerSiteLocationResponseAPI)) return;

    if (createSingleCustomerSiteLocationResponseAPI.status === 200) {
      if (fromCustomerPage) {
        dispatch(
          getSingleCustomerSiteLocationListData([
            {
              customer_data: {
                Id: Customer_Id,
              },
            },
          ])
        );
      }

      if (onCreated) {
        onCreated(createSingleCustomerSiteLocationResponseAPI.CustomerSiteLocation_Id);
      }
      setModal(false);
      toast.success(createSingleCustomerSiteLocationResponseAPI.message);

      // reset customer details object to default
      setCustomerDetails(initialCustomerDetails);
    } else {
      toast.error(createSingleCustomerSiteLocationResponseAPI.message);
    }
    dispatch(addSingleCustomerSiteLocationSuccess([]));
  }, [createSingleCustomerSiteLocationResponseAPI]);

  useEffect(() => {
    if (isEmpty(foodPreOrderSiteLocationCreateAPI)) return;
    if (foodPreOrderSiteLocationCreateAPI.status === 200) {
      toast.success(foodPreOrderSiteLocationCreateAPI.message);
      dispatch(foodPreOrderSiteLocationList());
      setModal(false);
      setCustomerDetails(initialCustomerDetails);
    } else {
      toast.error(foodPreOrderSiteLocationCreateAPI.message);
    }
    dispatch(foodPreOrderSiteLocationCreateSuccess([]));
  }, [foodPreOrderSiteLocationCreateAPI]);

  useEffect(() => {
    if (isEmpty(foodPreOrderSiteLocationUpdateAPI)) return;
    if (foodPreOrderSiteLocationUpdateAPI.status === 200) {
      toast.success(foodPreOrderSiteLocationUpdateAPI.message);
      dispatch(foodPreOrderSiteLocationList());
      setModal(false);
      setCustomerDetails(initialCustomerDetails);
    } else {
      toast.error(foodPreOrderSiteLocationUpdateAPI.message);
    }
    dispatch(foodPreOrderSiteLocationUpdateSuccess([]));
  }, [foodPreOrderSiteLocationUpdateAPI]);

  const [activeVerticalTab, setactiveVerticalTab] = useState(1);
  const [passedverticalSteps, setPassedverticalSteps] = useState([1]);

  function toggleVerticalTab(tab) {
    if (activeVerticalTab !== tab) {
      var modifiedSteps = [...passedverticalSteps, tab];
      setactiveVerticalTab(tab);
      setPassedverticalSteps(modifiedSteps);
    }
  }
  const handleAddEmailRow = () => {
    const { contactemailaddress_list } = customerDetails;
    const newEmailRow = {
      // get last id and add 1 if empty set 1
      Id:
        contactemailaddress_list?.length > 0
          ? contactemailaddress_list[contactemailaddress_list.length - 1]
              .ContactEmailAddress_Id + 1
          : 1,
      EmailAddress: "",
    };
    setCustomerDetails({
      ...customerDetails,
      contactemailaddress_list: [...contactemailaddress_list, newEmailRow],
    });
  };
  const handleAddPhoneRow = () => {
    const { contacttelephonenumber_list } = customerDetails;
    const newPhoneRow = {
      // get last id and add 1 if empty set 1
      Id:
        contacttelephonenumber_list?.length > 0
          ? contacttelephonenumber_list[contacttelephonenumber_list.length - 1]
              .Id + 1
          : 1,
      TelephoneNumber: "",
    };
    setCustomerDetails({
      ...customerDetails,
      contacttelephonenumber_list: [
        ...contacttelephonenumber_list,
        newPhoneRow,
      ],
    });
  };
  const handleRemoveEmailRow = (id) => {
    const { contactemailaddress_list } = customerDetails;
    const newEmailRow = contactemailaddress_list?.filter(
      (item) => item.Id !== id
    );
    setCustomerDetails({
      ...customerDetails,
      contactemailaddress_list: newEmailRow,
    });
  };
  const handleRemovePhoneRow = (id) => {
    const { contacttelephonenumber_list } = customerDetails;
    const newPhoneRow = contacttelephonenumber_list?.filter(
      (item) => item.Id !== id
    );

    setCustomerDetails({
      ...customerDetails,
      contacttelephonenumber_list: newPhoneRow,
    });
  };
  return (
    <>
      <AppModal
        open={modal}
        onClose={() => {
          setModal(false);
          setIsEdit(false);
        }}
        title={
          isEdit ? (
            <>
              Editing Site Location #{customerDetails?.Id}{" "}
              {customerDetails?.FullName}
            </>
          ) : (
            <>
              Add New Site Location{" "}
              {customerDetails?.BusinessName
                ? customerDetails?.BusinessName
                : customerDetails?.PersonFirstName +
                  " " +
                  customerDetails?.PersonLastName}
            </>
          )
        }
        icon={<StorefrontOutlinedIcon />}
        headerAccent="indigo"
        size="lg"
        hideFooter
      >
          {" "}
          <Row>
            <Col xl={12}>
              <Card>
                <CardBody className="form-steps">
                  <form className="vertical-navs-step">
                    <Row className="gy-5">
                      <Col lg={3}>
                        <Nav className="flex-column custom-nav nav-pills">
                          <NavItem>
                            <NavLink
                              href="#"
                              className={classnames({
                                active: activeVerticalTab === 1,
                                done:
                                  activeVerticalTab <= 11 &&
                                  activeVerticalTab > 1,
                              })}
                              onClick={() => {
                                toggleVerticalTab(1);
                              }}
                            >
                              <span className="step-title me-2">
                                <i className="ri-close-circle-fill step-icon me-2"></i>
                                Step A
                              </span>
                              Name & Address
                            </NavLink>
                          </NavItem>
                          <NavItem>
                            <NavLink
                              href="#"
                              className={classnames({
                                active: activeVerticalTab === 2,
                                done:
                                  activeVerticalTab <= 11 &&
                                  activeVerticalTab >= 2,
                              })}
                              onClick={() => {
                                toggleVerticalTab(2);
                              }}
                            >
                              <span className="step-title me-2">
                                <i className="ri-close-circle-fill step-icon me-2"></i>
                                Step B
                              </span>
                              Contact Information
                            </NavLink>
                          </NavItem>
                          <NavItem>
                            <NavLink
                              href="#"
                              className={classnames({
                                active: activeVerticalTab === 3,
                                done:
                                  activeVerticalTab <= 11 &&
                                  activeVerticalTab >= 3,
                              })}
                              onClick={() => {
                                toggleVerticalTab(3);
                              }}
                            >
                              <span className="step-title me-2">
                                <i className="ri-close-circle-fill step-icon me-2"></i>
                                Step C
                              </span>
                              Branding
                            </NavLink>
                          </NavItem>{" "}
                          <NavItem>
                            <NavLink
                              href="#"
                              className={classnames({
                                active: activeVerticalTab === 4,
                                done:
                                  activeVerticalTab <= 11 &&
                                  activeVerticalTab >= 4,
                              })}
                              onClick={() => {
                                toggleVerticalTab(4);
                              }}
                            >
                              <span className="step-title me-2">
                                <i className="ri-close-circle-fill step-icon me-2"></i>
                                Step D
                              </span>
                              Finish
                            </NavLink>
                          </NavItem>
                        </Nav>
                      </Col>
                      <Col lg={9}>
                        <div className="px-lg-4">
                          <TabContent activeTab={activeVerticalTab}>
                            <TabPane tabId={1}>
                              <TabStepABusinessNameAndAddress
                                customerDetails={customerDetails}
                                setCustomerDetails={setCustomerDetails}
                                toggleVerticalTab={toggleVerticalTab}
                                activeVerticalTab={activeVerticalTab}
                              />
                            </TabPane>

                            <TabPane tabId={2}>
                              <TabStepBBusinessContactInformation
                                customerDetails={customerDetails}
                                setCustomerDetails={setCustomerDetails}
                                handleRemoveEmailRow={handleRemoveEmailRow}
                                handleAddEmailRow={handleAddEmailRow}
                                handleRemovePhoneRow={handleRemovePhoneRow}
                                handleAddPhoneRow={handleAddPhoneRow}
                                toggleVerticalTab={toggleVerticalTab}
                                activeVerticalTab={activeVerticalTab}
                              />
                            </TabPane>
                            <TabPane tabId={3}>
                              <TabStepCBranding
                                customerDetails={customerDetails}
                                setCustomerDetails={setCustomerDetails}
                                handleRemoveEmailRow={handleRemoveEmailRow}
                                handleAddEmailRow={handleAddEmailRow}
                                handleRemovePhoneRow={handleRemovePhoneRow}
                                handleAddPhoneRow={handleAddPhoneRow}
                                toggleVerticalTab={toggleVerticalTab}
                                activeVerticalTab={activeVerticalTab}
                              />
                            </TabPane>

                            <TabPane tabId={4}>
                              <div>
                                <div>
                                  {isEdit ? (
                                    <>
                                      <span className={"h5"}>
                                        Editing Site Location Summary
                                      </span>
                                    </>
                                  ) : (
                                    <>
                                      {" "}
                                      <span className={"h5"}>
                                        Creating New Site Location Summary
                                      </span>
                                    </>
                                  )}
                                </div>
                                <div>
                                  <div className={"pt-2"}>
                                    <span>
                                      Step A -{" "}
                                      {customerDetails?.CustomerSiteLocationBusinessType_Id ===
                                      "1"
                                        ? "Business"
                                        : "Person"}
                                      {""}
                                      Name & Address
                                    </span>
                                  </div>
                                  {/*add line*/}
                                  <hr />
                                  <Row>
                                    {customerDetails?.CustomerSiteLocationBusinessType_Id ===
                                    "2" ? (
                                      <div>
                                        <Col lg={4}>
                                          <div>
                                            <span className={"fw-bold"}>
                                              Title:{" "}
                                            </span>
                                            {customerDetails?.PersonTitle}
                                          </div>
                                        </Col>

                                        <Col lg={4}>
                                          <div>
                                            <span className={"fw-bold"}>
                                              First Name:{" "}
                                            </span>

                                            {customerDetails?.PersonFirstName}
                                          </div>
                                        </Col>
                                        <Col lg={4}>
                                          <div>
                                            <span className={"fw-bold"}>
                                              Last Name:{" "}
                                            </span>

                                            {customerDetails?.PersonLastName}
                                          </div>
                                        </Col>
                                      </div>
                                    ) : (
                                      <Col lg={12}>
                                        <div>
                                          <span className={"fw-bold"}>
                                            Business Name:{" "}
                                          </span>

                                          {customerDetails?.BusinessName}
                                        </div>
                                      </Col>
                                    )}
                                    <Col lg={6}>
                                      <div>
                                        <span className={"fw-bold"}>
                                          Line address:{" "}
                                        </span>

                                        {customerDetails?.AddressLine1}
                                      </div>
                                    </Col>
                                    <Col lg={6}>
                                      <div>
                                        <span className={"fw-bold"}>
                                          Line address:{" "}
                                        </span>

                                        {customerDetails?.AddressLine2}
                                      </div>
                                    </Col>
                                    <Col lg={6}>
                                      <div>
                                        <span className={"fw-bold"}>
                                          Line address:{" "}
                                        </span>

                                        {customerDetails?.AddressLine3}
                                      </div>
                                    </Col>
                                    <Col lg={6}>
                                      <div>
                                        <span className={"fw-bold"}>
                                          Line address:{" "}
                                        </span>

                                        {customerDetails?.AddressLine4}
                                      </div>
                                    </Col>
                                    <Col lg={6}>
                                      <div>
                                        <span className={"fw-bold"}>
                                          City:{" "}
                                        </span>
                                        {customerDetails?.AddressCity}
                                      </div>
                                    </Col>

                                    <Col lg={6}>
                                      <div>
                                        <span className={"fw-bold"}>
                                          County:{" "}
                                        </span>
                                        {customerDetails?.AddressCounty}
                                      </div>
                                    </Col>
                                    <Col lg={6}>
                                      <div>
                                        <span className={"fw-bold"}>
                                          Postcode:{" "}
                                        </span>

                                        {customerDetails?.AddressPostCode}
                                      </div>
                                    </Col>
                                    <Col lg={6}>
                                      <div>
                                        <span className={"fw-bold"}>
                                          Country:{" "}
                                        </span>

                                        {customerDetails?.AddressCountry}
                                      </div>
                                    </Col>
                                  </Row>
                                </div>
                                <hr />
                                <div>
                                  <div className={"pt-2"}>
                                    <span>Step B - Contact Information</span>
                                  </div>
                                  <hr />
                                  <div>
                                    <Row>
                                      {customerDetails?.ContactTelephoneNumber && (
                                        <Col lg={6}>
                                          <div>
                                            <span className={"fw-bold"}>Phone: </span>
                                            {customerDetails.ContactTelephoneNumber}
                                          </div>
                                        </Col>
                                      )}
                                      {customerDetails?.ContactEmailAddress && (
                                        <Col lg={6}>
                                          <div>
                                            <span className={"fw-bold"}>Email: </span>
                                            {customerDetails.ContactEmailAddress}
                                          </div>
                                        </Col>
                                      )}
                                      <Col lg={6}>
                                        <div>Email List: </div>
                                        <div>
                                          {!isEmpty(
                                            customerDetails?.contactemailaddress_list
                                          ) ? (
                                            <>
                                              {" "}
                                              {customerDetails?.contactemailaddress_list?.map(
                                                (item, index) => {
                                                  return (
                                                    <div
                                                      className={
                                                        "d-flex flex-row p-1"
                                                      }
                                                      key={index}
                                                    >
                                                      <div>
                                                        <div className={"p-1"}>
                                                          {item.EmailAddress}{" "}
                                                        </div>
                                                      </div>
                                                    </div>
                                                  );
                                                }
                                              )}
                                            </>
                                          ) : (
                                            <>None</>
                                          )}
                                        </div>
                                      </Col>
                                      <Col lg={6}>
                                        <div>Phone List: </div>
                                        <div>
                                          {!isEmpty(
                                            customerDetails.contacttelephonenumber_list
                                          ) ? (
                                            <>
                                              {customerDetails.contacttelephonenumber_list?.map(
                                                (item, index) => {
                                                  return (
                                                    <div key={index}>
                                                      {item.TelephoneNumber}{" "}
                                                    </div>
                                                  );
                                                }
                                              )}
                                            </>
                                          ) : (
                                            <>None</>
                                          )}
                                        </div>
                                      </Col>
                                      {customerDetails?.UrlWebsiteHomepage && (
                                        <Col lg={6}>
                                          <div>
                                            <span className={"fw-bold"}>Website: </span>
                                            {customerDetails.UrlWebsiteHomepage}
                                          </div>
                                        </Col>
                                      )}
                                      {customerDetails?.UrlWebsiteBookATable && (
                                        <Col lg={6}>
                                          <div>
                                            <span className={"fw-bold"}>Book a Table: </span>
                                            {customerDetails.UrlWebsiteBookATable}
                                          </div>
                                        </Col>
                                      )}
                                      {customerDetails?.UrlLeaveAReview && (
                                        <Col lg={6}>
                                          <div>
                                            <span className={"fw-bold"}>Leave a Review: </span>
                                            {customerDetails.UrlLeaveAReview}
                                          </div>
                                        </Col>
                                      )}
                                      {customerDetails?.UrlLeaveFeedback && (
                                        <Col lg={6}>
                                          <div>
                                            <span className={"fw-bold"}>Leave Feedback: </span>
                                            {customerDetails.UrlLeaveFeedback}
                                          </div>
                                        </Col>
                                      )}
                                      {customerDetails?.Notes && (
                                        <Col lg={12}>
                                          <div>
                                            <span className={"fw-bold"}>Notes: </span>
                                            {customerDetails.Notes}
                                          </div>
                                        </Col>
                                      )}
                                      {customerDetails?.AddressPostCode && (
                                        <Col lg={12} className={"mt-2"}>
                                          <MapDetails
                                            singleCustomerPostcode={
                                              customerDetails?.AddressPostCode
                                            }
                                          />
                                        </Col>
                                      )}
                                    </Row>
                                  </div>
                                </div>
                              </div>
                              <div
                                className={"  pt-4 d-flex justify-content-end"}
                              >
                                <div className={"d-flex"}>
                                  {loading ||
                                  foodPreOrderSiteLocationCreateLoading ||
                                  foodPreOrderSiteLocationUpdateLoading ? (
                                    <LoadingSpinner size={"small"} row={true} />
                                  ) : (
                                    <span
                                      onClick={() => {
                                        //    updateCustomer();
                                        isEdit
                                          ? handleEditCustomer()
                                          : handleCreateCustomer("view");
                                      }}
                                      className={"btn btn-success "}
                                    >
                                      {isEdit ? "Update" : "Add New Site"}
                                    </span>
                                  )}
                                </div>
                              </div>
                            </TabPane>
                          </TabContent>
                        </div>
                      </Col>
                    </Row>
                  </form>
                </CardBody>
              </Card>
            </Col>
          </Row>
      </AppModal>
    </>
  );
}
